module.exports = __webpack_public_path__ + "img/edge_divers_bulle.82efb274.svg";